import { Chevron } from '@components/icons/chevron'
import { usePlaybook } from '@lib/hooks/usePlaybook'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'

import styles from './header.module.scss'

export const Header = observer(() => {
    const playbook = usePlaybook()

    return (
        <div className={classNames(styles.header)}>
            <div
                className={classNames(
                    styles.action,
                    !playbook.isHeaderBackButtonVisible && styles.hidden,
                )}
            >
                <button
                    onClick={async () => {
                        await playbook.backButtonFn?.()
                    }}
                >
                    <Chevron width='20px' direction='left' color='step-white' />
                </button>
            </div>
            <div className={styles.headerTextContainer}>
                <h1>{playbook.headerText}</h1>
            </div>
            <div
                className={classNames(
                    styles.action,
                    !playbook.isHeaderActionButtonVisible && styles.hidden,
                )}
            />
        </div>
    )
})

export default Header
